import { Reveal, SectionHead } from "@/components/Reveal";
import { TRUST_BADGES } from "@/constants/site";

const TrustBadges = () => (
  <section className="bg-charcoal py-20 sm:py-28 border-t border-white/10" data-testid="trust-badges-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <SectionHead
        dark
        eyebrow="Why Paliway"
        title="Built for the worst moment of your day"
      />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {TRUST_BADGES.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.08}>
            <div
              className="group h-full border border-white/10 bg-steel p-6 sm:p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-dispatch"
              data-testid={`trust-badge-${b.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <b.icon className="h-9 w-9 text-dispatch transition-transform duration-300 group-hover:scale-110" strokeWidth={1.8} />
              <h3 className="mt-5 font-display text-xl font-bold uppercase leading-tight text-white">{b.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-400">{b.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default TrustBadges;
